<div class="login-layout" *ngIf="isLoginPage()">
  <router-outlet></router-outlet>
</div>
<div id="main" class="layout-container" [class.layout-is-mobile]="viewState.isSmallish" *ngIf="!isLoginPage()">
  <div *ngIf="!isLoginPage() && !hideFraming" id="navbar" style="width: 100%;">        
    <!-- default to alertsense brand banners if no theme is found -->
    <app-layout-banner></app-layout-banner>
    <mat-toolbar *ngIf="!hideFraming" class="mat-elevation-z4" [style.background-color]="primaryColor"
      [style.color]="secondaryColor">
      <button mat-icon-button id="menu-button" (click)="navDrawer.toggle()" [attr.aria-label]="(navDrawer?.opened ?? drawerOpenInitial) ? 'Collapse menu' : 'Expand menu'">
        <mat-icon>menu</mat-icon>
      </button>
      <a id="brand-logo-browser" class="brand-logo desktop-only" routerLink="/" routerLinkActive="active"
        [style.background-image]="logoUri" [style.background-color]="primaryColor" aria-label="Home"></a>
      <div class="as-topnav-title" *ngIf="!!currentPage" [id]="currentPage" longPress (longPress)="onTitleLongPress()">
        {{ currentPage | translate:locale.language }}
      </div>
      <span class="toolbar-spacer"></span>
      <app-mock-selector></app-mock-selector>
      <button *ngIf="isBetaUx" mat-button id="leave-beta" (click)="leaveBeta()">
        <mat-icon>exit_to_app</mat-icon>
        <span class="menu-label">Exit Beta</span>
      </button>
      <button mat-icon-button id="feedback-button" (click)="showFeedback()" aria-label="Send feedback">
        <mat-icon>flag</mat-icon>
      </button>
      <button mat-button id="support-button" [matMenuTriggerFor]="supportMenu" style="color: white;">
        <mat-icon>help</mat-icon>
        <span class="menu-label">{{ 'Support' | translate:locale.language }}</span>
      </button>
      <mat-menu #supportMenu="matMenu" xPosition="before" yPosition="below">
        <a *ngFor="let link of supportInfo?.links" [href]="link.url" [target]="link.newTab ? '_blank' : '_self'" mat-menu-item>{{ link.text | translate:locale.language }}</a>
        <button [matMenuTriggerFor]="supportToolsMenu" mat-menu-item>{{ 'Support Tools' | translate:locale.language }}</button>
      </mat-menu>
      <mat-menu #supportToolsMenu="matMenu" xPosition="before" yPosition="below">
        <button mat-menu-item (click)="onViewAuthLog()">{{ 'Authentication Log' | translate:locale.language }}</button>
      </mat-menu>
      <button mat-button id="account-button" matTooltipClass="multiline-tooltip" [matMenuTriggerFor]="accountMenu" [matTooltip]="userTooltip" style="color: white;">
        <mat-icon *ngIf="isImpersonating">vpn_key</mat-icon>
        <mat-icon *ngIf="!isImpersonating">account_circle</mat-icon>
        <span class="menu-label">{{ 'Account' | translate:locale.language }}</span>
      </button>
      <mat-menu #accountMenu="matMenu" xPosition="before" yPosition="below">
        <mat-list>
          <mat-list-item *ngIf="user" id="loggedInUser" (click)="onUserClick()">
            <mat-icon matListItemIcon>account_circle</mat-icon>
            <p matListItemTitle><span>{{ userDisplayName }}</span></p>
            <p matListItemLine *ngIf="user?.agency && user?.tenantId"><span>{{ user?.agency }}</span></p>
          </mat-list-item>
        </mat-list>
        <button *ngIf="user && canImpersonate && !isImpersonating" mat-menu-item id="impersonateUser" (click)="showImpersonate()">
          <mat-icon class="with-text">vpn_key</mat-icon>{{ 'ImpersonateUser' | translate:locale.language }}
        </button>
        <button *ngIf="user && isImpersonating" mat-menu-item id="stopImpersonate" (click)="stopImpersonate()">
          <mat-icon class="with-text">vpn_key_off</mat-icon>{{ 'StopImpersonate' | translate:locale.language }}
        </button>
        <button *ngIf="isChangeEnvironmentsEnabled" mat-menu-item id="changeApi" (click)="showChangeApi()">
          <mat-icon class="with-text" matBadge="{{ isChangedEnvironment ? '!' : '' }}" matBadgeColor="accent">api</mat-icon>{{ 'ChangeApi' | translate:locale.language }}
        </button>
        <button *ngIf="user && isSuperAdmin && !isChangeEnvironmentsEnabled" mat-menu-item id="enableChangeApi" (click)="showEnableChangeEnvironments()">
          <mat-icon class="with-text">api</mat-icon>{{ 'Enable Change Environments' | translate:locale.language }}
        </button>
        <button mat-menu-item *ngIf="user && canOverrideFeaturesSupported" (click)="overrideFeatureSupported()">
          <mat-icon class="with-text">api</mat-icon>{{ 'Override Supported Features' | translate:locale.language }}
        </button>
        @if (canChangePassword) {
          <button id="changePassword" mat-menu-item (click)="changePassword()">
            <mat-icon class="with-text">lock</mat-icon>{{ 'ChangePassword' | translate:locale.language }}
          </button>
        }
        <button id="signOut" mat-menu-item (click)="logout()">
          <mat-icon class="with-text">logout</mat-icon>{{ 'SignOut' | translate:locale.language }}
        </button>
      </mat-menu>
    </mat-toolbar>
  </div>
  <mat-sidenav-container id="sidenav-container" class="layout-sidenav-container" autosize>
    <mat-sidenav #navDrawer *ngIf="!hideFraming" [mode]="viewState.isSmallish ? 'over' : 'side'"
      [opened]="drawerOpenInitial" role="directory" fixedInViewport="true" [fixedTopGap]="toolbarHeight">
      <div id="lazy-loading">
        <app-loading *ngIf="loadingRouteConfig || !user" [isCircle]="false"></app-loading>
      </div>
      <mat-nav-list *ngIf="user" id="nav-menu">
        <div class="brand-logo mobile-only" style="width: 100%;" [style.background-image]="logoUri"
          [style.background-color]="primaryColor">
          <a mat-list-item id="brand-logo-mobile" title="Konexus" routerLink="/" (click)="onRouteClick()"></a>
        </div>

        <app-nav-element *ngFor="let element of navElements" [element]="element" [level]="0"></app-nav-element>
        <p class="mat-list-item-header">&nbsp;</p>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content id="main-content" class="content" role="main" [style.margin-top.px]="toolbarHeight">
      <app-full-page-loading></app-full-page-loading>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
